function toPositiveInt(v, fallback) {
  const n = parseInt(String(v), 10)
  if (!Number.isFinite(n) || n < 0) return fallback
  return n
}

/**
 * 解析列表接口返回：兼容纯数组、以及带分页字段的对象（如 Laravel / 自定义包装）。
 * @param {any} res axios 拦截器返回的业务体（通常含 data）
 * @returns {{ rows: any[], total: number, page: number, perPage: number }}
 */
export function parseListAndPagination(res) {
  const empty = { rows: [], total: 0, page: 1, perPage: 10 }
  if (!res || typeof res !== 'object') return empty

  const raw = res.data
  /** 与 data 同级的分页字段（你方接口：data 为数组，total/page/per_page 在根上） */
  const rootTotal = res.total ?? res.meta?.total
  const rootPage = res.page ?? res.current_page ?? res.meta?.current_page
  const rootPerPage = res.per_page ?? res.page_size ?? res.meta?.per_page ?? res.meta?.pageSize

  if (raw == null) return empty

  if (Array.isArray(raw)) {
    return {
      rows: raw,
      total: toPositiveInt(rootTotal, raw.length),
      page: toPositiveInt(rootPage, 1) || 1,
      perPage: toPositiveInt(rootPerPage, 10) || 10
    }
  }

  if (typeof raw !== 'object') return empty

  let rows = []
  if (Array.isArray(raw.data)) rows = raw.data
  else if (Array.isArray(raw.list)) rows = raw.list
  else if (Array.isArray(raw.items)) rows = raw.items
  else if (Array.isArray(raw.records)) rows = raw.records

  const total = toPositiveInt(
    raw.total ?? raw.meta?.total ?? rootTotal,
    rows.length
  )
  const page =
    toPositiveInt(raw.page ?? raw.current_page ?? raw.meta?.current_page ?? rootPage, 1) || 1
  const perPage =
    toPositiveInt(
      raw.per_page ?? raw.page_size ?? raw.meta?.per_page ?? raw.meta?.pageSize ?? rootPerPage,
      10
    ) || 10

  return { rows, total, page, perPage }
}
